module.exports = __webpack_public_path__ + "img/production.d099add4.png";